export const PRODUCT_DETAILS = "PRODUCT_DETAILS"
export const PRODUCT_DETAILS_SUCCESSFUL = "PRODUCT_DETAILS_SUCCESSFUL"
export const PRODUCT_DETAILS_FAILED = "PRODUCT_DETAILS_FAILED"
export const PRODUCT_DETAILS_RESET = "PRODUCT_DETAILS_RESET"